import { render } from "./FormSecretInput.vue?vue&type=template&id=007dd375"
import script from "./FormSecretInput.vue?vue&type=script&lang=js"
export * from "./FormSecretInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nikita/Documents/works/novofamil/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__